import { forwardRef, type Ref, type SVGProps } from "react";
const IconUnconstrainedWalkThroughFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="m17.584 2.075 9.88 8.709c.981.885 1.537 2.111 1.536 3.394v14.09c0 1.232-1.058 2.232-2.364 2.232H5.364C4.058 30.5 3 29.5 3 28.267v-14.09c0-1.282.555-2.508 1.536-3.393l9.88-8.709a2.47 2.47 0 0 1 3.168 0m2.039 9.93a1 1 0 0 1-.235 1.394l-1.673 1.192C21.865 15.036 25 17.064 25 19.5c0 2.761-4.03 5-9 5s-9-2.239-9-5c0-1.483 1.162-2.814 3.007-3.73q.347-.172.726-.325a1 1 0 0 1 .15-.06l.018-.006.031-.011.001.003a1 1 0 0 1 .543 1.924l.002.006a8 8 0 0 0-.87.412C9.26 18.46 9 19.175 9 19.5s.26 1.039 1.607 1.787c1.28.71 3.182 1.213 5.393 1.213s4.113-.502 5.393-1.213C22.74 20.54 23 19.825 23 19.5s-.26-1.039-1.607-1.787c-.925-.514-2.177-.92-3.635-1.104l1.63 1.161a1 1 0 1 1-1.16 1.63l-3.069-2.186a2 2 0 0 1 0-3.258l3.07-2.186a1 1 0 0 1 1.394.235"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconUnconstrainedWalkThroughFilledSVG);
ForwardRef.displayName = "IconUnconstrainedWalkThroughFilled";
export { ForwardRef as IconUnconstrainedWalkThroughFilled };
